import { Controller } from "@hotwired/stimulus"

// Enables a submit control only after a confirmation field matches an expected
// value (case-insensitive, trimmed) — mirrors server-side typed confirmations.
export default class extends Controller {
  static targets = [ "input", "submit" ]
  static values = { expected: String }

  connect() {
    this.sync()
  }

  sync() {
    this.submitTarget.disabled = !this.matchesExpected()
  }

  matchesExpected() {
    const typed = this.inputTarget.value.toString().trim().toLowerCase()
    const expected = this.expectedValue.toString().trim().toLowerCase()
    return typed.length > 0 && typed === expected
  }
}
